import * as React from 'react';
import { QuizContainer } from './components/QuizContainer';

export const DVQuiz = (props) => {

    return (
        <QuizContainer quizId={props.quizId} />
    );

}
